import React from 'react'
import cx from 'classnames'
import { useHistory } from 'react-router-dom'

import {
  makeStyles,
  Grid,
  IconButton,
  ListItem,
  Tooltip,
  ListItemText,
  useTheme
} from '@material-ui/core'
import ArrowBack from '@material-ui/icons/ArrowBack'

import ProductImageThumb from '~/components/ProductImageThumb'
import SearchProductByStore from '~/components/Header/SearchProductByStore'
import useViewportSize from '~/components/useViewportSize'
import { useLiterals } from '~/components/Literals'

import { TYPES } from '~/actions'

const useSytles = makeStyles((theme) => ({
  wrapper: {
    zIndex: 500,
    width: '100%',

    [theme.breakpoints.up('md')]: {
      width: 408
    }
  },
  content: {
    gap: 8,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #70707040',
    '&.spacing': { padding: '16px 8px' },

    '& > div': {
      display: 'flex',
      alignItems: 'center',
      '&.contentSearch': {
        width: '100%',
        padding: 16
      }
    },
    '& > div:nth-child(2)': { width: '100%' }
  },
  text: {
    padding: '0 16px',
    '& span, & p': {
      color: '#000',
      ...theme.gofind.lineLimit(2),
      maxHeight: 27
    },
    '& p': {
      maxHeight: 22
    }
  },
  listItem: {
    padding: 0,
    [theme.breakpoints.up('md')]: {
      padding: 8
    }
  }
}))

function ProductHeader({ product, loading, view, position, config }) {
  const classes = useSytles()
  const history = useHistory()
  const viewport = useViewportSize()
  const theme = useTheme()

  const { getLiteral } = useLiterals()

  const urlDomain = window.location.toString()
  const isHideProductHeader = urlDomain.includes('produto/todos') || urlDomain.includes('loja/')

  const withProductDialog = !loading && product?.gtin !== 'all'

  const handleClick = () => {
    if (product.gtin === 'all') {
      history.goBack()
      return
    }

    history.push(`/produto/${product.gtin}/detalhes`, {
      fromApp: true,
      prevPath: history.location.pathname
    })
  }

  const handleBack = () => {
    if (view === TYPES.VIEW_STORE_DETAILS) {
      history.goBack()
    } else if (view === TYPES.VIEW_STORES && history?.location?.state?.from) {
      history.push(history.location.state.from)
    } else {
      history.push('/')
    }
  }

  const showArrowBack = () => {
    const isViewContext = Boolean(config.showContextViewStore)

    if (isViewContext) return view === TYPES.VIEW_STORE_DETAILS

    return [TYPES.VIEW_STORE_DETAILS, TYPES.VIEW_STORES].includes(view)
  }

  if (isHideProductHeader && Boolean(config.showContextViewEstablishment)) return null

  return (
    <Grid className={classes.wrapper}>
      <Grid className={cx(classes.content, { spacing: !config.showContextViewStore })}>
        {showArrowBack() && (
          <Grid>
            <Tooltip
              id="tooltip-back"
              title={getLiteral('1051')}
              placement="bottom-end"
              PopperProps={{ container: document.getElementById('gofind-finder') || document.body }}
            >
              <IconButton
                size="small"
                color="inherit"
                aria-label="go back"
                disabled={loading}
                onClick={handleBack}
                data-cy="backButton"
                style={{ marginLeft: 4 }}
              >
                <ArrowBack style={{ color: theme.palette.text.primary }} />
              </IconButton>
            </Tooltip>
          </Grid>
        )}

        <Grid className={cx({ contentSearch: !!config.showContextViewStore })}>
          {product && !!config.showContextViewStore && view !== TYPES.VIEW_STORE_DETAILS ? (
            <Grid
              style={{
                width: '100%',
                backgroundColor: theme.palette.background.default,
                borderRadius: 4
              }}
            >
              <SearchProductByStore product={product} position={position} config={config} />
            </Grid>
          ) : (
            product && (
              <ListItem
                className={classes.listItem}
                button={withProductDialog}
                onClick={handleClick}
                data-cy="product-header"
              >
                <ProductImageThumb product={product} />
                <ListItemText
                  className={classes.text}
                  primary={product.name}
                  secondary={product.description}
                />
              </ListItem>
            )
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default ProductHeader
